<template>
    <!-- Card style from the report designs: the card's title names the value,
         so the field is just the input, with its explanation in an info tip. -->
    <div    v-if="variant === 'cards'"
            class="py-1">
        <div class="flex items-center gap-3">
            <input  :id="field.key"
                    :name="field.key"
                    :value="modelValue"
                    :min="field.min"
                    :max="field.max"
                    :step="field.step"
                    :placeholder="field.placeholder"
                    :aria-label="field.label"
                    type="number"
                    class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    @input="onInput"
            >

            <info-tip   v-if="field.description"
                        :text="field.description"
            ></info-tip>
        </div>
        <p  v-if="error"
            class="m-0 mt-1 text-xs text-red-500">
            {{ error }}
        </p>
    </div>

    <report-field-row   v-else
                        :field-id="field.key"
                        :label="field.label"
                        :description="field.description"
                        :error="error"
    >
        <input  :id="field.key"
                :name="field.key"
                :value="modelValue"
                :min="field.min"
                :max="field.max"
                :step="field.step"
                :placeholder="field.placeholder"
                type="number"
                class="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                @input="onInput"
        >
    </report-field-row>
</template>

<script>
import ReportFieldRow from "../ReportFieldRow.vue"
import InfoTip from "@/components/elements/InfoTip.vue"

export default {
    name: "ReportNumberField",
    components: {ReportFieldRow, InfoTip},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [Number, String],
            default: null,
        },
        field: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            default: null,
        },
        // 'list' or 'cards'; see ReportSettingsPanel.
        variant: {
            type: String,
            default: 'list',
        },
    },
    methods: {
        onInput(event) {
            const raw = event.target.value
            // Keep empty as null rather than coercing to 0, which would silently
            // write a real threshold value the user never chose.
            this.$emit('update:modelValue', raw === '' ? null : Number(raw))
        },
    },
}
</script>
